import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root',
})
export class CriptoService {
  secret: string = 'ZXliejVkY3ZxMHE3dHQ3OHVkMGY0bXFrNDdkd3BkcHY=';

  constructor() {}

  encrypt(request: string) {
    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(request), this.secret, {
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }).toString();

    return encrypted;
  }

  decrypt(encrypted: string) {
    const decrypted = CryptoJS.AES.decrypt(encrypted, this.secret).toString(CryptoJS.enc.Utf8);
    return decrypted;
  }
}
